import { createTestIds } from '../../utils';

export const getFormTestIds = createTestIds('form', [] as const);
